import React from 'react';

export function Terms() {
  return (
    <div className="space-y-4">
      <div className="bg-primary rounded-lg p-4 text-center">
        <h1 className="text-xl font-semibold text-white">CONDICIONES GENERALES DE USO</h1>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <div className="space-y-6">
          <div className="space-y-4">
            <h2 className="text-lg font-semibold text-primary">1. Aceptación de las Condiciones</h2>
            <p className="text-gray-700">
              El acceso y uso de la aplicación "Sandra" implica la aceptación plena y sin reservas de las presentes condiciones generales. Si el usuario no está de acuerdo con alguna de las condiciones aquí establecidas, deberá abstenerse de utilizar la aplicación.
            </p>
          </div>

          <div className="space-y-4">
            <h2 className="text-lg font-semibold text-primary">2. Objeto</h2>
            <p className="text-gray-700">
              Las presentes condiciones regulan el acceso y uso de la aplicación "Sandra", cuyo propósito es ofrecer información sobre los servicios de estética y quiromasaje proporcionados por Sandra Palacios Herrero.
            </p>
          </div>

          <div className="space-y-4">
            <h2 className="text-lg font-semibold text-primary">3. Obligaciones del Usuario</h2>
            <p className="text-gray-700">El usuario se compromete a:</p>
            <div className="space-y-2 pl-4">
              <p><strong>Uso Responsable:</strong> Utilizar la aplicación de forma diligente y conforme a la ley, la moral y el orden público.</p>
              <p><strong>Prohibición de Contenidos Ilegales:</strong> Abstenerse de introducir o difundir contenidos de carácter racista, xenófobo, pornográfico, de apología del terrorismo o que atenten contra los derechos humanos.</p>
            </div>
          </div>

          <div className="space-y-4">
            <h2 className="text-lg font-semibold text-primary">4. Exclusión de Garantías y Responsabilidad</h2>
            <div className="space-y-2 pl-4">
              <p><strong>Funcionamiento de la Aplicación:</strong> Sandra Palacios Herrero no garantiza la inexistencia de interrupciones o errores en el acceso a la aplicación.</p>
              <p><strong>Responsabilidad por Contenidos:</strong> No se responsabiliza de las decisiones tomadas a partir de la información suministrada en la aplicación ni de los daños y perjuicios producidos en el usuario o terceros con motivo de actuaciones que tengan como único fundamento la información obtenida en la aplicación.</p>
            </div>
          </div>

          <div className="space-y-4">
            <h2 className="text-lg font-semibold text-primary">5. Modificaciones</h2>
            <p className="text-gray-700">
              Sandra Palacios Herrero se reserva el derecho de modificar, en cualquier momento y sin necesidad de previo aviso, la presentación y configuración de la aplicación, así como las presentes condiciones generales.
            </p>
          </div>

          <div className="space-y-4">
            <h2 className="text-lg font-semibold text-primary">6. Enlaces</h2>
            <p className="text-gray-700">
              La aplicación "Sandra" puede contener enlaces a sitios web de terceros. La presencia de estos enlaces tiene una finalidad informativa, no constituyendo en ningún caso una invitación a la contratación de productos o servicios que se ofrezcan en el sitio de destino. Sandra Palacios Herrero no se responsabiliza ni de los contenidos ni de los servicios ofrecidos en los sitios enlazados.
            </p>
          </div>

          <div className="space-y-4">
            <h2 className="text-lg font-semibold text-primary">7. Legislación Aplicable y Jurisdicción</h2>
            <p className="text-gray-700">
              Las relaciones establecidas entre Sandra Palacios Herrero y el usuario se regirán por lo dispuesto en la normativa española vigente. Sandra Palacios Herrero y el usuario, con renuncia expresa a cualquier otro fuero que pudiera corresponderles, se someten al de los juzgados y tribunales de Valencia, España.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}